import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { updateOrganizer, getOrganizerById } from "api/company.api";
import OrganizerForm from "components/company/OrganizerForm";

export default function EditOrganizer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState("");

  useEffect(() => {
    fetchOrganizer();
  }, []);

  const fetchOrganizer = async () => {
    try {
      const res = await getOrganizerById(id);
      const data = res.data.data;

      setInitialData({
        ...data,
        projectModules: Array.isArray(data.projectModules)
        ? data.projectModules
        : typeof data.projectModules === "string"
        ? data.projectModules.split(",")
        : [],
      });
    } catch (err) {
      console.error("Fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (data) => {
    try {
      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
        if (key === "projectModules") {
          value.forEach((m) =>
            formData.append("projectModules[]", m)
          );
          return;
        }

       
        if (key === "companyLogo") {
          if (value instanceof File) {
            formData.append("companyLogo", value);
          }
          return;
        }

        if (value !== null) {
          formData.append(key, value ?? "");
        }
      });
      
      await updateOrganizer(id, formData);
      navigate("/admin/companies");
    } catch (err) {
      console.error("UPDATE ERROR:", err.response?.data || err.message);
      setAlert(
        err.response?.data?.message ||
        "Failed to create company"
      );
    }
  };

  if (loading) return <p className="p-6">Loading...</p>;

  return (
    <OrganizerForm
      initialData={initialData}
      onSubmit={handleSubmit}
      submitLabel="Update Organizer"
      alert={alert}
      setAlert={setAlert}
      onBack={() => navigate(-1)}
    />
  );
}
